/* global $, query_string, data */
import * as d3 from 'd3'
import { values } from 'd3-collection'
import { easeLinear } from 'd3-ease'
import { line } from 'd3-shape'
import _ from 'underscore'
import table from 'bam-node-savant-table/table'

let ticking = false
let isFixedHeaderShowing = false
const tableDivId = 'sprint_speed'

$(document).ready(() => {
    $('#ddlTeamId').change(() => {
        $('#lblTeamId').html($('#ddlTeamId option:selected').text())
    })
    $('#ddlPlayer1').change(() => {
        $('#lblPlayer1').html(
            $('#ddlPlayer1 option:selected').text() || 'Player 1'
        )
    })
    $('#ddlPlayer2').change(() => {
        $('#lblPlayer2').html(
            $('#ddlPlayer2 option:selected').text() || 'Player 2'
        )
    })
    $('#ddlPlayer3').change(() => {
        $('#lblPlayer3').html(
            $('#ddlPlayer3 option:selected').text() || 'Player 3'
        )
    })
    $('#ddlPlayer4').change(() => {
        $('#lblPlayer4').html(
            $('#ddlPlayer4 option:selected').text() || 'Player 4'
        )
    })

    $('form').submit(false)

    if (query_string.team) {
        $('#ddlTeamId').val(query_string.team).attr('selected', true)
        $('#lblTeamId').html($('#ddlTeamId option:selected').text())
    }

    if (query_string.player1) {
        $('#ddlPlayer1').val(query_string.player1).attr('selected', true)
        $('#lblPlayer1').html($('#ddlPlayer1 option:selected').text())
    }

    if (query_string.player2) {
        $('#ddlPlayer2').val(query_string.player2).attr('selected', true)
        $('#lblPlayer2').html($('#ddlPlayer2 option:selected').text())
    }

    if (query_string.player3) {
        $('#ddlPlayer3').val(query_string.player3).attr('selected', true)
        $('#lblPlayer3').html($('#ddlPlayer3 option:selected').text())
    }

    if (query_string.player4) {
        $('#ddlPlayer4').val(query_string.player4).attr('selected', true)
        $('#lblPlayer4').html($('#ddlPlayer4 option:selected').text())
    }

    if (data && data.length > 0) {
        let dataLoad = data
        if (query_string.team) {
            dataLoad = _.filter(
                dataLoad,
                (d) => Number(d.team_id) === Number(query_string.team)
            )
        }

        let field = 'seconds_since_hit_'
        let highlight = []
        let sortOrder = 'asc'
        if (query_string.type === 'percent') {
            field = 'percent_rank_'
            highlight = [0, 50, 100]
            sortOrder = 'desc'
        }

        const width = $(`#${tableDivId}`).outerWidth()
        let repeatHeaders = false
        if (width <= 768) {
            repeatHeaders = 15
        }

        // eslint-disable-next-line no-new, new-cap
        new table({
            id: 'sprint_speed',
            repeatHeader: repeatHeaders,
            headers: [
                {
                    name: 'Player',
                    field: 'href',
                    customSortField: 'name_display_last_first',
                    headerClass:
                        'th-component-header align-left table-static-column',
                    fieldClass: 'tr-data align-left table-static-column',
                    photo: '<img class="player-mug" onError="this.onerror=null;this.src=\'https://content.mlb.com/images/headshots/current/60x60/generic.png\';" src="https://content.mlb.com/images/headshots/current/60x60/{1}.png">',
                    photoId: 'player_id',
                },
                {
                    name: 'Bats',
                    field: 'bat_side',
                    headerClass: 'th-component-header',
                    fieldClass: 'tr-data',
                },
                {
                    name: 'Team',
                    field: 'team_id',
                    headerClass: 'th-component-header align-center',
                    fieldClass: 'tr-data align-center',
                    photo: '<img class="table-team-logo" src="https://www.mlbstatic.com/team-logos/{1}.svg" />',
                    photoId: 'team_id',
                    photoOnly: true,
                },
                {
                    name: 'Position',
                    field: 'position_name',
                    headerClass: 'th-component-header',
                    fieldClass: 'tr-data',
                },
                {
                    name: 'Age',
                    field: 'age',
                    headerClass: 'th-component-header',
                    fieldClass: 'tr-data',
                },
                {
                    name: '0ft',
                    field: `${field}000`,
                    type: 'number',
                    headerClass: 'th-component-header',
                    fieldClass: 'tr-data split_000',
                },
                {
                    name: '5ft',
                    field: `${field}005`,
                    type: 'number',
                    headerClass: 'th-component-header',
                    fieldClass: 'tr-data split_005',
                    highlight,
                },
                {
                    name: '10ft',
                    field: `${field}010`,
                    type: 'number',
                    headerClass: 'th-component-header',
                    fieldClass: 'tr-data split_010',
                    highlight,
                },
                {
                    name: '15ft',
                    field: `${field}015`,
                    type: 'number',
                    headerClass: 'th-component-header',
                    fieldClass: 'tr-data split_015',
                    highlight,
                },
                {
                    name: '20ft',
                    field: `${field}020`,
                    type: 'number',
                    headerClass: 'th-component-header',
                    fieldClass: 'tr-data split_020',
                    highlight,
                },
                {
                    name: '25ft',
                    field: `${field}025`,
                    type: 'number',
                    headerClass: 'th-component-header',
                    fieldClass: 'tr-data split_025',
                    highlight,
                },
                {
                    name: '30ft',
                    field: `${field}030`,
                    type: 'number',
                    headerClass: 'th-component-header',
                    fieldClass: 'tr-data split_030',
                    highlight,
                },
                {
                    name: '35ft',
                    field: `${field}035`,
                    type: 'number',
                    headerClass: 'th-component-header',
                    fieldClass: 'tr-data split_035',
                    highlight,
                },
                {
                    name: '40ft',
                    field: `${field}040`,
                    type: 'number',
                    headerClass: 'th-component-header',
                    fieldClass: 'tr-data split_040',
                    highlight,
                },
                {
                    name: '45ft',
                    field: `${field}045`,
                    type: 'number',
                    headerClass: 'th-component-header',
                    fieldClass: 'tr-data split_045',
                    highlight,
                },
                {
                    name: '50ft',
                    field: `${field}050`,
                    type: 'number',
                    headerClass: 'th-component-header',
                    fieldClass: 'tr-data split_050',
                    highlight,
                },
                {
                    name: '55ft',
                    field: `${field}055`,
                    type: 'number',
                    headerClass: 'th-component-header',
                    fieldClass: 'tr-data split_055',
                    highlight,
                },
                {
                    name: '60ft',
                    field: `${field}060`,
                    type: 'number',
                    headerClass: 'th-component-header',
                    fieldClass: 'tr-data split_060',
                    highlight,
                },
                {
                    name: '65ft',
                    field: `${field}065`,
                    type: 'number',
                    headerClass: 'th-component-header',
                    fieldClass: 'tr-data split_065',
                    highlight,
                },
                {
                    name: '70ft',
                    field: `${field}070`,
                    type: 'number',
                    headerClass: 'th-component-header',
                    fieldClass: 'tr-data split_070',
                    highlight,
                },
                {
                    name: '75ft',
                    field: `${field}075`,
                    type: 'number',
                    headerClass: 'th-component-header',
                    fieldClass: 'tr-data split_075',
                    highlight,
                },
                {
                    name: '80ft',
                    field: `${field}080`,
                    type: 'number',
                    headerClass: 'th-component-header',
                    fieldClass: 'tr-data split_080',
                    highlight,
                },
                {
                    name: '85ft',
                    field: `${field}085`,
                    type: 'number',
                    headerClass: 'th-component-header',
                    fieldClass: 'tr-data split_085',
                    highlight,
                },
                {
                    name: '90ft',
                    field: `${field}090`,
                    type: 'number',
                    headerClass: 'th-component-header',
                    fieldClass: 'tr-data split_090',
                    highlight,
                },
            ],
            data: dataLoad,
            showRank: true,
            defaultSort: `${field}090`,
            defaultSortDirection: sortOrder,
        })
    } else {
        $('#NoData').html('<h1>No Data Found.</h2>')
    }

    function addStaticHeader(divId) {
        const width = $(`#${divId}`).outerWidth()
        // $(".tr-component-row th").removeClass("column-sort");

        if (width && width > 767) {
            // console.log(width);
            let tableCell = 0

            // Set TH Width before applying fixed-header
            $('.default-table-row')
                .first()
                .children('td')
                .each(function setCellWidth() {
                    const cellWidth = $(this).outerWidth()
                    $(`.tr-component-row th:nth-child(${tableCell + 1})`).css(
                        'width',
                        cellWidth
                    )
                    tableCell++ // eslint-disable-line
                })

            $(`#${divId} table thead`).addClass('fixed-header')
            tableCell = 0

            // Set TD Width before applying fixed-header
            $('.tr-component-row')
                .children('th')
                .each(function setCellWidth() {
                    const cellWidth = $(this).outerWidth()
                    $(`.default-table-row td:nth-child(${tableCell + 1})`).css(
                        'width',
                        cellWidth
                    )
                    tableCell++ // eslint-disable-line
                })
        }
    }

    function checkHeaderPosition(divId) {
        const scrollPosY = window.scrollY
        const posTop = $(`#${divId}`).offset().top
        const height = $(`#${divId} table thead`).height()
        if (!isFixedHeaderShowing && posTop < scrollPosY) {
            isFixedHeaderShowing = true
            addStaticHeader(divId)
        } else if (isFixedHeaderShowing && posTop - height > scrollPosY) {
            $(`#${divId} table thead`).removeClass('fixed-header')
            isFixedHeaderShowing = false
        }
    }

    window.addEventListener('scroll', () => {
        if (!ticking && data.length) {
            window.requestAnimationFrame(() => {
                checkHeaderPosition(tableDivId)
                ticking = false
            })

            ticking = true
        }
    })

    $(document).on('click', 'th.th-component-header', () => {
        isFixedHeaderShowing = false
        checkHeaderPosition(tableDivId)
    })

    window.addEventListener('resize', () => {
        if (isFixedHeaderShowing) {
            addStaticHeader(tableDivId)
        }
    })

    $('#btnUpdate').click(() => {
        window.location.href = `/running_splits?type=${$(
            '#ddlType'
        ).val()}&bats=${$('#ddlBats').val()}&year=${$(
            '#ddlSeason'
        ).val()}&position=${$('#ddlPosition').val()}&team=${$(
            '#ddlTeamId'
        ).val()}&min=${$('#ddlMin').val()}`
    })
    $('#btnCSV').click(() => {
        window.location.href = `/running_splits?type=${$(
            '#ddlType'
        ).val()}&bats=${$('#ddlBats').val()}&year=${$(
            '#ddlSeason'
        ).val()}&position=${$('#ddlPosition').val()}&team=${$(
            '#ddlTeamId'
        ).val()}&min=${$('#ddlMin').val()}&csv=true`
    })

    function updateUrl() {
        window.history.pushState(
            '',
            '',
            `?player1=${$('#ddlPlayer1').val()}&player2=${$(
                '#ddlPlayer2'
            ).val()}&player3=${$('#ddlPlayer3').val()}&player4=${$(
                '#ddlPlayer4'
            ).val()}&type=${$('#ddlType').val()}&bats=${$(
                '#ddlBats'
            ).val()}&year=${$('#ddlSeason').val()}&position=${$(
                '#ddlPosition'
            ).val()}&team=${$('#ddlTeamId').val()}&min=${$('#ddlMin').val()}`
        )
    }

    function startRace() {
        $('#viz').html('')

        const players = _.filter(data, (d) => {
            let meta = $('#ddlPlayer1').val().split('_')
            const playerId1 = meta[0]
            const batSide1 = meta[1]

            meta = $('#ddlPlayer2').val().split('_')
            const playerId2 = meta[0]
            const batSide2 = meta[1]

            meta = $('#ddlPlayer3').val().split('_')
            const playerId3 = meta[0]
            const batSide3 = meta[1]

            meta = $('#ddlPlayer4').val().split('_')
            const playerId4 = meta[0]
            const batSide4 = meta[1]

            return (
                (Number(d.player_id) === Number(playerId1) &&
                    d.bat_side === batSide1) ||
                (Number(d.player_id) === Number(playerId2) &&
                    d.bat_side === batSide2) ||
                (Number(d.player_id) === Number(playerId3) &&
                    d.bat_side === batSide3) ||
                (Number(d.player_id) === Number(playerId4) &&
                    d.bat_side === batSide4)
            )
        })

        let width = $('#viz').width()

        if (!width || width === 0 || width > 700) {
            width = 700
        }

        const canvasWidth = width
        const canvasHeight = 300

        const margin = { top: 20, right: 20, bottom: 30, left: 50 }
        width = canvasWidth - margin.left - margin.right
        const height = canvasHeight - margin.top - margin.bottom

        const chartArea = d3
            .select('#viz')
            .append('div')
            .attr('id', 'viz-holder')
            .style('position', 'relative')
            .style('text-align', 'center')
            .style('min-height', canvasHeight)

        const svg = chartArea
            .append('svg')
            .attr('id', 'visual-layer')
            .attr('width', canvasWidth)
            .attr('height', canvasHeight)
            .style('position', 'absolute')
            .style('top', '0px')
            .style('left', '0px')
            .append('g')
            .attr('transform', `translate(${margin.left},${margin.top})`)

        svg.append('defs')
            .append('style')
            .attr('type', 'text/css')
            .text(
                "@import url('https://fonts.googleapis.com/css?family=Roboto+Condensed');"
            )

        const x = d3.scaleLinear().range([0, width]).domain([0, 90])
        const y = d3.scaleLinear().range([50, height]).domain([0, 3])

        const ftBreakdown = []
        for (let i = 0; i < 95; i += 5) {
            ftBreakdown.push(i)
        }

        const linePath = line()
            .x((d) => x(Number(d.ft)))
            .y((d) => y(Number(d.time)))

        function move(point, t, split) {
            if (t >= split.length - 2) {
                // t = -1;
                d3.selectAll('.race').transition()
                const id = d3.select(point).attr('id').split('_')[1]
                d3.select(`#id_${id}`)
                    .style('stroke', '#f00')
                    .style('stroke-width', '5px')
            } else {
                t += 1 // eslint-disable-line

                d3.select(point)
                    .transition()
                    .ease(easeLinear)
                    .duration(
                        (d) =>
                            (Number(d[t + 1].time) - Number(d[t].time)) * 1000
                    )

                    .attr('x', x(split[t + 1].ft))
                    .attr('y', y(split[t + 1].y))
                    .attr('transform', 'translate(-15,-15)')

                    .on('end', function handleEnd() {
                        move(this, t, split)
                    })
            }
        }

        // eslint-disable-next-line
        function race(players) {
            const splits = {}

            for (let i = 0; i < players.length; i++) {
                const id = players[i].player_id
                const batSide = players[i].bat_side
                const splitKey = `${id}_${batSide}`
                splits[splitKey] = []
                Object.keys(players[i]).forEach((key) => {
                    if (key.indexOf('_since') > -1) {
                        const ft = key.substring(key.length - 2, key.length)
                        const time = players[i][key]
                        splits[splitKey].push({
                            ft,
                            time,
                            y: i,
                            bat_side: players[i].bat_side,
                            player_id: id,
                            name: players[i].name_display_last_first,
                        })
                    }
                })
            }

            const g = svg
                .selectAll('players')
                .data(values(splits))
                .enter()
                .append('g')

            /*          var t = 0;
            var duration = (Number(split[t+1].time)-Number(split[t].time))*1000;
          console.log(duration) */

            g.append('line')
                .attr('id', (d) => `id_${d[0].player_id}_${d[0].bat_side}`)
                .attr('x1', x(0))
                .attr('x2', x(90))
                .attr('y1', (d) => y(d[0].y))
                .attr('y2', (d) => y(d[0].y))
                .attr('stroke', '#000')

            g.append('text')
                .attr('x', x(45))
                .attr('y', (d) => y(d[0].y - 0.25))
                .attr('text-anchor', 'middle')
                .style('font-size', '11px')
                .text((d) => `${d[0].name} - ${d[0].bat_side}`)

            ftBreakdown.forEach((ft) => {
                g.append('circle')
                    .attr('cx', x(ft))
                    .attr('cy', (d) => y(d[0].y))
                    .attr('r', 2)

                if (ft === 0 || ft === 30 || ft === 60 || ft === 90) {
                    g.append('text')
                        .attr('x', x(ft))
                        .attr('y', (d) => y(d[0].y + 0.25))
                        .style('font-size', '12px')
                        .attr('text-anchor', 'middle')
                        .text(`${ft}ft`)
                }
            })

            // draw bases
            Object.keys(splits).forEach((key) => {
                let i = splits[key][0].y

                i -= 0.1

                const hp = [
                    {
                        ft: 0,
                        time: i,
                    },
                    {
                        ft: -1.5,
                        time: i,
                    },
                    {
                        ft: -2,
                        time: i - 0.075,
                    },
                    {
                        ft: -1.5,
                        time: i - 0.15,
                    },
                    {
                        ft: 0,
                        time: i - 0.15,
                    },
                    {
                        ft: 0,
                        time: i,
                    },
                ]

                svg.append('path')
                    .attr('d', linePath(hp))
                    .attr('stroke', '#000')
                    .attr('fill', 'none')

                const first = [
                    {
                        ft: 90,
                        time: i,
                    },
                    {
                        ft: 92.5,
                        time: i,
                    },
                    {
                        ft: 92.5,
                        time: i - 0.15,
                    },
                    {
                        ft: 90,
                        time: i - 0.15,
                    },
                    {
                        ft: 90,
                        time: i,
                    },
                ]

                svg.append('path')
                    .attr('d', linePath(first))
                    .attr('stroke', '#000')
                    .attr('fill', 'none')
            })

            g.append('image')
                .attr('id', (d) => `pt_${d[0].player_id}_${d[0].bat_side}`)

                .attr('class', 'race')
                .attr('x', (d) => x(d[0].ft))
                .attr('y', (d) => y(d[0].y))
                .attr('height', '25')
                .attr('width', '25')
                .attr(
                    'xlink:href',
                    (d) =>
                        `https://content.mlb.com/images/headshots/current/60x60/${d[0].player_id}.png`
                )
                .attr('transform', 'translate(-15,-15)')
                .transition()
                .ease(easeLinear)
                .duration((d) => (Number(d[1].time) - Number(d[0].time)) * 100)
                .attr('x', (d) => x(d[1].ft))
                .attr('y', (d) => y(d[1].y))
                .attr('transform', 'translate(-15,-15)')
                .on('end', function handleEnd(d) {
                    move(this, 0, d)
                })

            /* svg.append("image")
              .attr("x",x(splits[t].ft))
              .attr("y",y(splits[t].time))
              .attr("r",5)
              .transition()
            .ease(d3.easeLinear)
              .delay(duration)
              .attr("cx",x(splits[t+1].ft))
              .attr("cy",y(splits[t+1].time))
              .on("end",function() { move(this) }); */

            // }
        }

        race(players)
    }

    if (
        query_string.player1 ||
        query_string.player2 ||
        query_string.player3 ||
        query_string.player4
    ) {
        $('#viz').css('min-height', '300px')
        startRace()
    }

    $('#btnRace').click(() => {
        if (
            $('#ddlPlayer1').val() !== '' ||
            $('#ddlPlayer2').val() !== '' ||
            $('#ddlPlayer3').val() !== '' ||
            $('#ddlPlayer4').val() !== ''
        ) {
            $('#viz').css('min-height', '300px')

            updateUrl()
            startRace()
        }
    })
})

document.querySelectorAll('#leaderboard .form-control').forEach((el) => {
    el.addEventListener('change', (e) => {
        const id = el.getAttribute('id')
        const type = id.slice(3)
        const { selectedIndex } = e.target
        document.querySelector(`.label-change-${type}`).innerText =
            e.target[selectedIndex].text
    })
})
